import { Alert } from "antd";
import { Link } from "react-router-dom";
import type { AuthFormError } from "../authFormError";

/**
 * The persistent half of an auth failure (EQU-118).
 *
 * Nothing here is on a timer. That is the whole point: the toast beside it
 * disappears after 4.5s and leaves the form looking untouched, and this stays
 * until the next submit clears it.
 */
export function AuthErrorAlert({ error }: { error: AuthFormError | null }) {
	if (!error) return null;

	return (
		<Alert
			type="error"
			showIcon
			className="auth-card__error"
			message={error.description}
			description={
				error.nextAction ? (
					<Link to={error.nextAction.to}>{error.nextAction.label}</Link>
				) : undefined
			}
		/>
	);
}
